import React, { Component } from 'react';
import { Pagination } from "react-bootstrap";
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from './components/Table';
import API from '../../services/API';
import { handleFieldChange } from "../../Utils";
import {PAGE_LIMIT} from "../../data/config";

class AdkBidFactorAll extends Component {
    constructor() {
        super();

        this.state = {
            affidValues: [],
            subidValues: [],
            report: [],
            sortParam: null,
            sortOrder: 1,
            pagesTotal: 0,
            activePage: 1,
            isLoading: false
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handlePageSelect = this.handlePageSelect.bind(this);
    }

    componentDidMount() {
        API.AdkFeeds.getIds()
            .then(affids => this.setState({ affidValues: affids }));
    }

    componentWillUpdate(nextProps, nextState) {
        const { report, sortParam, sortOrder } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(report, sortParam, sortOrder);

            this.setState({ report, activePage: 1 });
        }
    }

    sortReport(report, sortParam, sortOrder) {
        report.sort((objA, objB) => {
            if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
            else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

            return 0;
        });
    }

    handleSubmit(filters, type) {
        this.setState({ isLoading: true });

        if(type === 'subid') {
            API.AdkBidFactor.getSubidsAll(filters).then(subids => {
                this.setState({ subidValues: subids, isLoading: false })
            })
        }
        else {
            API.AdkBidFactor.getAll(filters, type).then(({ report }) => {
                const pagesTotal = Math.ceil(report.length / PAGE_LIMIT);

                this.setState({ report, pagesTotal, activePage: 1, isLoading: false })
            });
        }
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    handlePageSelect(activePage) {
        this.setState({ activePage });
    }

    getTable() {
        let { report, activePage } = this.state;


        if(report.length) {
            const pageStart = ( activePage - 1 ) * PAGE_LIMIT;
            const pageEnd = activePage * PAGE_LIMIT;
            report = report.slice(pageStart, pageEnd);

            return <Table report={report} onSortChange={this.handleSort} />;
        }

        return <p>No Data</p>;
    }

    render() {
        const { isLoading, affidValues, subidValues } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="Adk Bid Factor All"/>
                <Form onSubmit={this.handleSubmit} affidValues={affidValues} subidValues={subidValues}/>

                {this.getTable()}

                <Pagination
                    items={this.state.pagesTotal}
                    maxButtons={20}
                    onSelect={this.handlePageSelect}
                    activePage={this.state.activePage}
                />
            </Container>
        );
    }
}

export default AdkBidFactorAll;


// WEBPACK FOOTER //
// ./src/scenes/AdkBidFactorAll/index.js